import { createSelector, current } from '@reduxjs/toolkit';

export const getContacts = (state) => state.contact.contacts;

export const getDefinedContacts = (state) => {
  return state.contact.contacts.filter((applicant, index) => {
    try {
      if (state.contact.contacts[index].applicantId !== null) return true;
      return false;
    } catch {
      return false;
    }
  });
};

export const getContactByApplicantId = createSelector(
  [getContacts, (state, applicantId) => applicantId],
  (contacts, applicantId) =>
    contacts.find((contact) => contact.applicantId === applicantId)
);

export const getContactIndex = createSelector(
  [getContacts, (state, applicantId) => applicantId],
  (contacts, applicantId) =>
    contacts.findIndex((contact) => contact.applicantId === applicantId)
);

export const getContactsValid = createSelector(
  getDefinedContacts,
  (contacts) =>
    contacts.filter((contact) => {
      return (
        contact.emailMatch !== true ||
        contact.emailValid !== true ||
        contact.phoneNumberValid !== true ||
        contact.error !== false
      );
    }).length <= 0
);

export const getContactIndexFromApplicantId = (state, applicantId) => {
  let index = getContactIndex({ contact: current(state) }, applicantId);
  return index;
};

export const getContactIndexFromMeta = (state, action) => {
  const {
    meta: {
      arg: { applicantId },
    },
  } = action;
  let index = getContactIndex({ contact: current(state) }, applicantId);
  return index;
};

export const getContactIndexFromPayload = (state, action) => {
  const {
    payload: { applicantId },
  } = action;
  let index = getContactIndex({ contact: current(state) }, applicantId);
  return index;
};

export const hasDualContacts = (state) => {
  return (
    state.contacts.filter((contact) => contact.applicantId !== null).length > 1
  );
};

export default {
  getContacts,
};
